import { client } from './axios';

const currencyList = () => client.get(`/currency`);
export const commonService = {
  currencyList,
};
